/* src/app/forms/produtos/mercadolivre/meli-item-attrib/meli-item-attrib.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content {
  position: relative;
  padding-top: 6px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.attrib-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
  align-items: stretch;
}
.attrib-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--tem-border, #f0f0f0);
  border-radius: var(--tem-radius, 8px);
  padding: 10px 12px;
  min-height: 130px;
  background: var(--tem-surface, #fff);
}
.attrib-card-required {
  border-color: var(--tem-danger, #ff4d4f);
}
.attrib-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}
.attrib-card-title {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.not-applicable {
  flex-shrink: 0;
  white-space: nowrap;
  font-size: var(--tem-fs-sm, 12px);
  margin-bottom: 0;
}
.attrib-card-warn {
  color: var(--tem-danger, #ff4d4f);
  flex-shrink: 0;
}
.attrib-card-close {
  cursor: pointer;
  flex-shrink: 0;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
}
.attrib-card-close:hover {
  color: var(--tem-danger, #ff4d4f);
}
.attrib-card-hint {
  font-size: var(--tem-fs-sm, 11px);
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
  min-height: 28px;
  max-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 6px;
}
.attrib-card-content {
  margin-top: auto;
}
.multi-field {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.multi-field .left {
  flex: 1 1 65%;
}
.multi-field .right {
  flex: 1 1 35%;
  min-width: 90px;
}
.full {
  width: 100%;
}
.field-action {
  cursor: pointer;
  margin-left: 4px;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
}
.field-action:hover {
  color: var(--tem-deep, #1890ff);
}
.spacer {
  flex: 1;
}
.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 8px;
}
.search-actions {
  margin-top: 10px;
  width: 400px;
  max-width: 100%;
}
.search-actions input {
  width: 100%;
}
actions-buttons {
  width: 100%;
}
/*# sourceMappingURL=meli-item-attrib.component.css.map */
